import { startAuthentication, startRegistration } from '@simplewebauthn/browser'
import { api } from '../api/client.ts'

/**
 * ВХОД ЛИЦОМ ИЛИ КОД-ПАРОЛЕМ ТЕЛЕФОНА
 *
 * Телефон хранит тайный ключ у себя и отдаёт его только хозяину — по
 * лицу, отпечатку или коду разблокировки. Приложение при этом не видит
 * ни лица, ни отпечатка: оно получает подпись, а проверяет её сервер.
 *
 * Здесь только разговор с браузером. Вся проверка — на сервере,
 * иначе это была бы не защита, а вежливая просьба.
 */

/** Умеет ли это устройство хранить ключ у себя. */
export async function canUsePasskeys(): Promise<boolean> {
  try {
    if (!window.PublicKeyCredential) return false
    return await PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable()
  } catch {
    return false
  }
}

/** Завести ключ на этом устройстве. Человек уже вошёл. */
export async function addPasskey(label: string): Promise<void> {
  const { options } = await api<{ options: Parameters<typeof startRegistration>[0]['optionsJSON'] }>(
    '/api/passkeys/register/start',
    { method: 'POST' },
  )

  const response = await startRegistration({ optionsJSON: options })

  await api('/api/passkeys/register/finish', {
    method: 'POST',
    body: { label, response },
  })
}

/**
 * Войти ключом.
 *
 * Почту не спрашиваем: телефон сам знает, какие ключи у него есть для
 * этого адреса, и сам предложит нужный. Кто пришёл — выяснится
 * по подписи.
 */
export async function loginWithPasskey(): Promise<{
  accessToken: string
  refreshToken: string
  user: unknown
}> {
  const started = await api<{
    ticket: string
    options: Parameters<typeof startAuthentication>[0]['optionsJSON']
  }>('/api/passkeys/login/start', { method: 'POST' })

  const response = await startAuthentication({ optionsJSON: started.options })

  return api('/api/passkeys/login/finish', {
    method: 'POST',
    body: { ticket: started.ticket, response },
  })
}
